<template>
    <div class="layout__position-left layout__width-100">

        <el-form :model="searchParams" status-icon :rules="rules" ref="searchParams">

            <div class="layout__padding-clear text__align-center layout__width-100">
                <div class="layout__search-field__insights-250px">
                    <p class="layout__margin__bottom-10 text__align-left">Date Range</p>
                    <el-form-item prop="salesDateRange">
                        <el-date-picker
                            v-model="searchParams.salesDateRange"
                            type="daterange"
                            align="left"
                            start-placeholder="Start Date"
                            end-placeholder="End Date"
                            :picker-options="pickerOptions"
                            format="dd/MM/yyyy"
                            value-format="dd/MM/yyyy">
                        </el-date-picker>
                    </el-form-item>
                </div>
                <div class="layout__search-field__insights-8">
                    <p class="layout__margin__bottom-10 text__align-left">Territory</p>
                    <el-form ref="customer">
                        <el-form-item prop="search">
                            <el-select v-model="searchParams.territory" filterable placeholder="Territory" clearable @change="handleTerritorySelect">
                                <el-option v-for="territory in territories"
                                           :key="territory.territory"
                                           :label="territory.territory"
                                           :value="territory.territory">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="layout__search-field__insights-8">
                    <p class="layout__margin__bottom-10 text__align-left">Brand</p>
                    <el-form ref="customer">
                        <el-form-item prop="search">
                            <el-select v-model="searchParams.brand" filterable placeholder="Brand" clearable @change="handleBrandSelect">
                                <el-option v-for="brand in brands"
                                           :key="brand.brand"
                                           :label="brand.brand"
                                           :value="brand.brand">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="layout__search-field__insights-8">
                    <p class="layout__margin__bottom-10 text__align-left">Branch</p>
                    <el-form ref="customer">
                        <el-form-item prop="search">
                            <el-select v-model="searchParams.branch" filterable placeholder="Branch" clearable @change="handleBranchSelect">
                                <el-option v-for="branch in branches"
                                           :key="branch.branch"
                                           :label="branch.branch"
                                           :value="branch.branch">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="layout__search-field__insights-8">
                    <p class="layout__margin__bottom-10 text__align-left">&nbsp;</p>
                    <el-form ref="customer">
                        <el-form-item prop="search">
                            <el-radio-group v-model="searchParams.datatype" size="mini" @input="handleDataTypeChange">
                                <el-radio-button label="Orders"></el-radio-button>
                                <el-radio-button label="Invoices"></el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                </div>
                <!--<div class="layout__search-field__customer">
                    <p class="layout__margin__bottom-10 text__align-left">Freetext Search</p>
                    <el-form ref="search">
                        <el-form-item prop="searchParams">
                            <el-input placeholder="Search" v-model="searchParams.salesFreeText"
                                    clearable
                                    autofocus></el-input>
                        </el-form-item>
                    </el-form>
                </div>-->
            </div>

        </el-form>

        <el-button class="button-red button__base button__insights" v-on:click="getSalesRefresh('searchParams')">Refresh Data
        </el-button>

        <el-button class="button-teal button__base button__insights" :disabled="this.sales.length === 0" v-on:click="csv()">Download CSV
        </el-button>

    </div>

</template>

<script>

    import Axios from 'axios';
    import moment from 'moment';
    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';

    export default {
        name: "customerSalesSearch",
        mixins: [axios, csvDownloadHelper, dataFormatter],
        props: {
            searchParams: {},
            sales: []
        },
        data() {
            return {
                territories: [],
                brands: [],
                branches: [],
                serviceRouteUrl: `${process.env.VUE_APP_INSIGHTSAPIHOST}`,
                exportDate: new Date().toLocaleDateString('en-GB') + '_sales.csv',
                downloadUrl: '',
                salesFreeText: '',
                myChart: Object,
                pickerOptions: {
                    shortcuts: [{
                        text: 'This month',
                        onClick(picker) {
                            picker.$emit('pick', [new Date(), new Date()]);
                        }
                    }, {
                        text: 'This year',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date(new Date().getFullYear(), 0);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Last 6 months',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setMonth(start.getMonth() - 6);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                }
            }
        },
        created() {
            console.log('CREATED')
            const date = new Date();
            date.setDate(date.getDate() - 7)
            console.log('created date')

            this.searchParams.salesDateRange[0] = moment().startOf('month').format('DD/MM/YYYY');
            this.searchParams.salesDateRange[1] = moment().endOf('month').format('DD/MM/YYYY');
            this.searchParams.territory = '';
            this.searchParams.brand = '';
            this.searchParams.branch = '';
            this.searchParams.datatype = 'Orders';

            console.log(this.searchParams)
        },
        mounted() {
            console.log('MOUNTED');
            this.getSales('searchParams');
        },
        destroyed() {
            console.log('DESTROYED')
            this.searchParams.salesDateRange[0] = moment().startOf('month').format('DD/MM/YYYY');
            this.searchParams.salesDateRange[1] = moment().endOf('month').format('DD/MM/YYYY');
            this.searchParams.territory = '';
            this.searchParams.brand = '';
            this.searchParams.branch = '';
            this.searchParams.datatype = 'Orders';

            console.log(this.searchParams)
        },
        beforeUpdate() {
            window.sessionStorage.setItem('_search', JSON.stringify(this.searchParams));
        },
        methods: {
            getSalesRefresh(searchParams) {
                this.territories.length = 0;
                this.brands.length = 0;
                this.branches.length = 0;

                this.getSales('searchParams');
            },
            getSales(searchParams) {

                this.$refs[searchParams].validate((valid)  => { 
                    if (valid) {

                        console.log('before')
                        console.log(this.searchParams)

                        let searchTerms = Object.assign({}, this.searchParams)
                        console.log('searchTerms')
                        console.log(searchTerms)

                        if (searchTerms.salesDateRange[0] !== null && searchTerms.salesDateRange[0].length !== undefined) {
                            if (searchTerms.salesDateRange[0].toString().includes('/')) {
                                searchTerms.salesDateRange[0] = this.convertDate(searchTerms.salesDateRange[0])
                            }
                        }

                        if (searchTerms.salesDateRange[1] !== null && searchTerms.salesDateRange[1].length !== undefined) {
                            if (searchTerms.salesDateRange[1].toString().includes('/')) {
                                searchTerms.salesDateRange[1] = this.convertDate(searchTerms.salesDateRange[1])
                            }
                        }

                        console.log('after search is copied')
                        console.log(this.searchParams)

                        console.log('after search is copied - new object')
                        console.log(searchTerms)

                        var startDate = moment(searchTerms.salesDateRange[0]).format('YYYY%2FMM%2FDD'),
                            endDate = moment(searchTerms.salesDateRange[1]).format('YYYY%2FMM%2FDD'),
                            dataType = searchTerms.datatype,
                            endpoint = this.serviceRouteUrl + '/api/v1/insights/order/GetCustomerSales?startDate=' + startDate + '&endDate=' + endDate + '&dataType=' + dataType;

                        console.log(endpoint)

                        this.$parent.loading = true;

                        Axios.get(endpoint,  this.returnHeaderUsingToken())
                        .then(response => {
                            var lookup = {},
                                orders = response.data.customerSales;

                            if (searchTerms.territory != '') {
                                var filtered = orders.filter(function(item){
                                    return item.territory == searchTerms.territory;
                                });
                                orders = filtered;
                            }

                            if (searchTerms.brand != '') {
                                var filtered = orders.filter(function(item){
                                    return item.brand == searchTerms.brand;
                                });
                                orders = filtered;
                            }

                            if (searchTerms.branch != '') {
                                var filtered = orders.filter(function(item){
                                    return item.branch == searchTerms.branch;
                                });
                                orders = filtered;
                            }

                            if (this.territories.length === 0) {
                                lookup = {};
                                for (var order, i = 0; order = orders[i++];) {
                                    var territory = order.territory;
                                    if (territory !== "" && territory !== null) {
                                        if (!(territory in lookup)) {
                                            lookup[territory] = 1;
                                            this.territories.push({territory: territory});
                                        }
                                    }
                                }
                                this.territories.sort((a, b)=> {
                                    var a1 = a.territory.toLowerCase();
                                    var b1 = b.territory.toLowerCase();
                                    return a1<b1 ?-1:a1> b1? 1 :0;
                                })
                            }

                            if (this.brands.length === 0) {
                                lookup = {};
                                for (var order, i = 0; order = orders[i++];) {
                                    var brand = order.brand;
                                    if (brand !== "") {
                                        if (!(brand in lookup)) {
                                            lookup[brand] = 1;
                                            this.brands.push({brand: brand});
                                        }
                                    }
                                }
                                this.brands.sort((a, b)=> {
                                    var a1 = a.brand.toLowerCase();
                                    var b1 = b.brand.toLowerCase();
                                    return a1<b1 ?-1:a1> b1? 1 :0;
                                })
                            }

                            if (this.branches.length === 0) {
                                lookup = {};
                                for (var order, i = 0; order = orders[i++];) {
                                    var branch = order.branch;
                                    if (branch !== "") {
                                        if (!(branch in lookup)) {
                                            lookup[branch] = 1;
                                            this.branches.push({branch: branch});
                                        }
                                    }
                                }
                                this.branches.sort((a, b)=> {
                                    var a1 = a.branch.toLowerCase();
                                    var b1 = b.branch.toLowerCase();
                                    return a1<b1 ?-1:a1> b1? 1 :0;
                                })
                            }

                            this.$parent.sales = orders;

                            if (orders.length > 0) {
                                var total_orders = 0,
                                    total_avgorder = 0,
                                    total_toolkit = 0,
                                    total_email = 0,
                                    total_bespoke = 0,
                                    total_instantprint = 0,
                                    total_photofixr = 0,
                                    total_directmailr = 0,
                                    total_delivery = 0,
                                    total_total = 0,
                                    total_listprice = 0,
                                    total_costprice = 0,
                                    total_marginpounds = 0;
                        
                                for (var order, i = 0; order = orders[i++];) {
                                    const temp_total_orders = Number(order.orders);
                                    if (!isNaN(temp_total_orders)) {
                                        total_orders += temp_total_orders;
                                    }
                                    const temp_total_avgorder = Number(order.avgorder);
                                    if (!isNaN(temp_total_avgorder)) {
                                        total_avgorder += temp_total_avgorder;
                                    }
                                    const temp_total_toolkit = Number(order.toolkit);
                                    if (!isNaN(temp_total_toolkit)) {
                                        total_toolkit += temp_total_toolkit;
                                    }
                                    const temp_total_email = Number(order.email);
                                    if (!isNaN(temp_total_email)) {
                                        total_email += temp_total_email;
                                    }
                                    const temp_total_bespoke = Number(order.bespoke);
                                    if (!isNaN(temp_total_bespoke)) {
                                        total_bespoke += temp_total_bespoke;
                                    }
                                    const temp_total_instantprint = Number(order.instantprint);
                                    if (!isNaN(temp_total_instantprint)) {
                                        total_instantprint += temp_total_instantprint;
                                    }
                                    const temp_total_photofixr = Number(order.photofixr);
                                    if (!isNaN(temp_total_photofixr)) {
                                        total_photofixr += temp_total_photofixr;
                                    }
                                    const temp_total_directmailr = Number(order.directmailr);
                                    if (!isNaN(temp_total_directmailr)) {
                                        total_directmailr += temp_total_directmailr;
                                    }
                                    const temp_total_delivery = Number(order.delivery);
                                    if (!isNaN(temp_total_delivery)) {
                                        total_delivery += temp_total_delivery;
                                    }
                                    const temp_total_total = Number(order.total);
                                    if (!isNaN(temp_total_total)) {
                                        total_total += temp_total_total;
                                    }
                                    const temp_total_listprice = Number(order.listprice);
                                    if (!isNaN(temp_total_listprice)) {
                                        total_listprice += temp_total_listprice;
                                    }
                                    const temp_total_costprice = Number(order.costprice);
                                    if (!isNaN(temp_total_costprice)) {
                                        total_costprice += temp_total_costprice;
                                    }
                                    const temp_total_marginpounds = Number(order.marginpounds);
                                    if (!isNaN(temp_total_marginpounds)) {
                                        total_marginpounds += temp_total_marginpounds;
                                    }
                                }

                                this.$parent.totals = [];
                                this.$parent.totals.push({spaces:"&nbsp;", orders:total_orders, avgorder:total_avgorder, toolkit:total_toolkit, email:total_email, bespoke:total_bespoke, instantprint:total_instantprint, directmailr: total_directmailr, photofixr:total_photofixr, delivery:total_delivery, total:total_total, listprice:total_listprice, costprice:total_costprice, marginpounds:total_marginpounds});
                            }

                            this.$nextTick(() => { // Loading should be closed asynchronously
                                this.$parent.loading = false;
                            });
                        })
                        .catch(error => {
                            if (error.response) {
                                this.$message.error('Sorry there has been an issue retrieving the information you requested.');
                            }

                            this.$nextTick(() => { // Loading should be closed asynchronously
                                this.$parent.loading = false;
                            });

                            this.$parent.sales = [];
                        })
                    } else {
                        return false;
                    }
                })
            },
            handleTerritorySelect(val) {
                console.log('handleTerritorySelect');

                if (val == null) {
                    val = '';
                }

                console.log(val);
                this.searchParams.territory = val;
                this.searchParams.brand = '';
                this.searchParams.branch = '';

                this.brands.length = 0;
                this.branches.length = 0;

                this.getSales('searchParams');
            },
            handleBrandSelect(val) {
                console.log('handleBrandSelect');

                if (val == null) {
                    val = '';
                }

                console.log(val);
                this.searchParams.brand = val;
                this.searchParams.branch = '';

                this.branches.length = 0;

                this.getSales('searchParams');
            },
            handleBranchSelect(val) {
                console.log('handleBranchSelect');

                if (val == null) {
                    val = '';
                }

                console.log(val);
                this.searchParams.branch = val;

                this.getSales('searchParams');
            },
            handleDataTypeChange(val) {
                console.log('handleDataTypeChange');
                console.log(val);
                this.searchParams.datatype = val;

                this.getSales('searchParams');
            },
            csv() {
                var monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];

                const fields = [
                    {label: 'Month', value: (row, field) => monthNames[row.month - 1]},
                    {label: 'Year', value: 'year'},
                    {label: 'Branch', value: 'branch'},
                    {label: 'Name', value: 'name'},
                    {label: 'Brand', value: 'brand'},
                    {label: 'Territory', value: 'territory'},
                    {label: 'Orders', value: 'orders'},
                    {label: 'Avg Order', value: 'avgorder'},
                    {label: 'Toolkit', value: 'toolkit'},
                    {label: 'Directmailr', value: 'directmailr'},
                    {label: 'Email', value: 'email'},
                    {label: 'Bespoke', value: 'bespoke'},
                    {label: 'InstantPrint', value: 'instantprint'},
                    {label: 'PhotoFixr', value: 'photofixr'},
                    {label: 'Delivery', value: 'delivery'},
                    {label: 'Total', value: 'total'},
                    {label: 'List Price', value: 'listprice'},
                    {label: 'Cost Price', value: 'costprice'},
                    {label: 'Margin (£)', value: 'marginpounds'},
                    {label: 'Margin (%)', value: (row, field) => row.marginpercent + '%'}
                ];

                this.downloadCsv(this.exportDate, fields, this.sales)
            }
        }
    };
</script>